import React, { useState, useRef } from "react";
import CustomTriggerForm from "../custom-trigger-form/CustomTriggerForm";
import optionIcon from "../../assets/img/option-icon.png";

export default function TriggerCard({
    trigger,
    onUpdate,
    turbineModels = [],
    isUpdating = false,
    isEditing = false,
    onEditToggle,
    onOptionMenuToggle
}) {
    const optionRef = useRef();

    const [editedTrigger, setEditedTrigger] = useState({
        is_subsequent: trigger.is_subsequent,
        min_peak_current: trigger.min_peak_current,
        max_peak_current: trigger.max_peak_current,
        min_probability: trigger.min_probability ? Math.round(trigger.min_probability * 100) : null,
        max_distance_km: trigger.max_distance_km ? trigger.max_distance_km * 1000 : null,
        turbine_models: trigger.turbine_model ? [trigger.turbine_model] : [],
    });
    const handleSave = async () => {
        try {
            const valuesToSend = {
                is_subsequent: editedTrigger.is_subsequent,
                min_peak_current: editedTrigger.min_peak_current,
                max_peak_current: editedTrigger.max_peak_current,
                min_probability: editedTrigger.min_probability ? parseFloat(editedTrigger.min_probability) / 100 : null,
                max_distance_km: editedTrigger.max_distance_km ? editedTrigger.max_distance_km / 1000 : null,
                turbine_model: editedTrigger.turbine_models.length > 0 ? editedTrigger.turbine_models[0] : null,
            };

            await onUpdate(trigger.id, valuesToSend);
            onEditToggle();
        } catch (error) {
            console.error("Error updating trigger:", error);
        }
    };


    const handleOptionClick = (e) => {
        e.stopPropagation();
        if (optionRef.current) {
            const rect = optionRef.current.getBoundingClientRect();
            onOptionMenuToggle(trigger.id, 'lightning', {
                top: rect.bottom + window.scrollY,
                left: rect.left + window.scrollX + 15,
            });
        }
    };

    if (isEditing) {
        return (
            <div className={`trigger editing ${isUpdating ? 'updating-row' : ''}`}>
                <CustomTriggerForm
                    triggerData={editedTrigger}
                    onTriggerChange={setEditedTrigger}
                    turbineModels={turbineModels}
                />
                <div className='trigger-action-container'>
                    <button
                        className='org-btn cancel-btn'
                        disabled={isUpdating}
                        onClick={onEditToggle}
                    >
                        X
                    </button>
                    <button
                        className='org-btn success-btn'
                        disabled={isUpdating}
                        onClick={handleSave}
                    >
                        ✔
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className={`trigger ${isUpdating ? 'updating-row' : ''}`}>
            <div
                className='trigger-cell'
                onClick={handleOptionClick}
            >
                <img
                    src={optionIcon}
                    className='action-icon trigger-option-btn'
                    ref={optionRef}
                />
            </div>
            <span className="inline-input">
                <p className="trigger-value">
                    {trigger.is_subsequent ? "Subsequent " : "First "} stroke
                </p>
            </span>
            <span>
                <p className="trigger-key">Min peak current:</p>{" "}
                <p className="trigger-value">
                    {trigger.min_peak_current !== null ? trigger.min_peak_current + "kA" : "N/A"}
                </p>
            </span>
            <span>
                <p className="trigger-key">Max peak current:</p>{" "}
                <p className="trigger-value">
                    {trigger.max_peak_current !== null ? trigger.max_peak_current + "kA" : "N/A"}
                </p>
            </span>
            <span>
                <p className="trigger-key">Min probability:</p>{" "}
                <p className="trigger-value">
                    {trigger.min_probability !== null
                        ? parseFloat((trigger.min_probability * 100).toFixed(2)) + "%"
                        : "N/A"}
                </p>
            </span>
            <span>
                <p className="trigger-key">Max distance:</p>{" "}
                <p className="trigger-value">
                    {trigger.max_distance_km !== null && trigger.max_distance_km !== 0
                        ? Math.trunc(trigger.max_distance_km * 1000) + "m"
                        : "N/A"}
                </p>
            </span>
            <span>
                <p className="trigger-key">Turbine models</p>{" "}
                <p className="trigger-value">
                    {trigger.turbine_model ? trigger.turbine_model : "N/A"}
                </p>
            </span>
        </div>
    );
};
